// import * as bootstrap from 'bootstrap';

let mobileMenuToggle;
let mobileNav;
mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
mobileNav = document.querySelector(".mobile-nav");

mobileMenuToggle.addEventListener("click", () => {
    if (!document.startViewTransition) {
        mobileNav.classList.toggle("mobile-nav-show");
        return;
    }

    // With a View Transition:
    document.startViewTransition(
        () => mobileNav
            .classList.toggle("mobile-nav-show")
    );

})

const activePath = window.location.pathname;
const navLinks = document.querySelectorAll(".navbar-links-a");
navLinks.forEach(link => {
    if (link.getAttribute("href") === activePath) {
        link.classList.add("active");
    }
})

